import type {
    ActivateTeamMemberRequest,
    DeactivateTeamMemberRequest,
    TeamMemberDetailsRequest,
    TeamMembersListRequest,
    UpdateTeamMemberRequest,
    UnThrottleTeamMemberRequest,
    TeamMemberRevokeInvitationRequest,
    TeamMemberResendInvitationRequest,
    TeamMemberUpdateRoleRequest,
} from '@/types/api/teamMembers';

type TeamMembersApi = {
    details: (id: string) => TeamMemberDetailsRequest['url'];
    list: TeamMembersListRequest['url'];
    deactivate: (id: string) => DeactivateTeamMemberRequest['url'];
    activate: (id: string) => ActivateTeamMemberRequest['url'];
    update: (id: string) => UpdateTeamMemberRequest['url'];
    unthrottle: (id: string) => UnThrottleTeamMemberRequest['url'];
    revokeInvitation: (id: string) => TeamMemberRevokeInvitationRequest['url'];
    resendInvitation: (id: string) => TeamMemberResendInvitationRequest['url'];
    updateRole: (id: string) => TeamMemberUpdateRoleRequest['url'];
};

export const teamMembersApi: TeamMembersApi = {
    details: (id: string) => `users/${id}`,
    list: 'users',
    deactivate: (id: string) => `users/${id}/deactivate`,
    activate: (id: string) => `users/${id}/activate`,
    update: (id: string) => `users/${id}`,
    unthrottle: (id: string) => `users/${id}/unthrottle`,
    revokeInvitation: (id: string) => `users/${id}/revoke-invitation`,
    resendInvitation: (id: string) => `users/${id}/resend-invitation`,
    updateRole: (id: string) => `users/${id}/roles`,
};
